import { render, staticRenderFns } from "./ServiceAddNew.vue?vue&type=template&id=385f59b1&"
import script from "./ServiceAddNew.vue?vue&type=script&lang=js&"
export * from "./ServiceAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports